import { getSalesforceLeadPayload } from '@/services/helpers/get-salesforce-lead-payload.helper';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
export function useGetSalesforceLeadPayload() {
    var _a = useSelector(function (state) { return state; }), widget = _a.widget, dinTest = _a.dinTest, wizard = _a.wizard;
    return useMemo(function () { return getSalesforceLeadPayload({ widget: widget, dinTest: dinTest, wizard: wizard }); }, [widget, dinTest, wizard]);
}
